export enum MacrosDataEventObject {
  CREATE_NEW_MACRO = 'create_new_macro',
  CREATE_MACRO = 'create_macro',
  EDIT_MACRO = 'edit_macro',
  DELETE_MACRO = 'delete_macro',
  SUGGESTED_MACRO = 'suggested_macro',
  MACRO_LIST = 'macro_list',
  ADD_BRANCH_CONDITION = 'add_branch_condition',
  SAVE_MACRO_BRANCH_CONDITION = 'save_macro_branch_condition',
  SAVE_MACRO_ACTIONS = 'save_macro_actions',
  WARNING_MOVE_MACRO_VALIDATE = 'warning_move_macro_validate',
  WARNING_MOVE_MACRO_CANCEL = 'warning_move_macro_cancel',
  MACRO_TEAMMATE_INPUT = 'macro_teammate_input',
  MACRO_TEAMMATE_INPUT_SUBMIT = 'macro_teammate_input_submit',
  MACRO_USE_TEMPLATE = 'macro_use_template',
}
